export default __webpack_public_path__ + "static/media/03_photo.fa3e6455.jpg";